'use client'

import {
  MEMBERSHIP_NAMESPACE,
  SIMULATOR_VERSION
} from '@/global/constants/featureFlags'
import { useGetExperimentVariant } from '@/global/hooks'
import { useExperimentStore } from '@/global/store/useExperimentStore'
import { FunctionComponent } from 'react'
import { Loader } from '@/global/components/Loader'
import { Simulator } from '@/modules/simulator/views/Simulator'
import { SimulatorProvider } from '@/modules/simulator/providers'

type SupportedSimulatorVersion = 'V15'

const namespace = MEMBERSHIP_NAMESPACE
const keys = [SIMULATOR_VERSION]
const allowedVariantsByKey: Record<string, SupportedSimulatorVersion[]> = {
  [SIMULATOR_VERSION]: ['V15']
}

const SimulatorExperimentHandler: FunctionComponent = () => {
  useGetExperimentVariant({
    namespace,
    keys,
    allowedVariantsByKey
  })

  const experiments = useExperimentStore(state => state.experiments)
  const simulatorVersion = experiments[SIMULATOR_VERSION]

  if (!simulatorVersion?.value) {
    return (
      <>
        <Loader />
      </>
    )
  }

  return (
    <SimulatorProvider simulatorVersion={simulatorVersion}>
      <Simulator />
    </SimulatorProvider>
  )
}

export { SimulatorExperimentHandler }
